/*
 * CI APPROVER WORKFLOW — OWNER ONLY (launch batch). The approver signs off-server; this screen only carries
 * the request out and the signature back. The server verifies every signature against registered public keys.
 */
import { useState } from "react";
import axios from "axios";
import { KeyRound } from "lucide-react";
import { Panel, Note } from "./ConsolePrimitives";
import { deliverDownload } from "../../utils/deliverDownload";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/founder/ci-approvals`;
const errorOf = (e) => e?.response?.data?.detail || "Request failed.";

export const CIApproverPanel = () => {
  const [candidate, setCandidate] = useState("");
  const [kid, setKid] = useState("");
  const [request, setRequest] = useState(null);
  const [sig, setSig] = useState("");
  const [msg, setMsg] = useState(null);

  const fetchRequest = async () => {
    setMsg(null);
    try {
      const { data } = await axios.post(`${API}/request`, { candidate_id: candidate, approver_kid: kid });
      setRequest(data.request);
      const blob = new Blob([JSON.stringify(data.request)], { type: "application/json" });
      await deliverDownload(blob, `approval-request-${candidate}.json`, "application/json");
      setMsg(`Sign it off-server: ${data.sign_with}`);
    } catch (e) { setMsg(errorOf(e)); }
  };

  const submit = async () => {
    setMsg(null);
    try {
      await axios.post(`${API}/submit`, { candidate_id: candidate, request, approval_sig: sig.trim() });
      setMsg("Approved: signature verified.");
      setRequest(null); setSig("");
    } catch (e) { setMsg(errorOf(e)); }
  };

  return (
    <Panel title="Approver workflow" icon={KeyRound} testId="fc-ci-approver">
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <input data-testid="fc-ci-approver-candidate" placeholder="Candidate id" value={candidate}
               onChange={(e) => setCandidate(e.target.value)} />
        <input data-testid="fc-ci-approver-kid" placeholder="Approver key id" value={kid}
               onChange={(e) => setKid(e.target.value)} />
        <button data-testid="fc-ci-approver-request" disabled={!candidate || !kid} onClick={fetchRequest}>
          Get signing request
        </button>
      </div>
      {request && (
        <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
          <input data-testid="fc-ci-approver-signature" placeholder="Signature (hex)" value={sig}
                 onChange={(e) => setSig(e.target.value)} style={{ minWidth: 320 }} />
          <button data-testid="fc-ci-approver-submit" disabled={!sig.trim()} onClick={submit}>Submit signature</button>
        </div>
      )}
      {msg && <Note testId="fc-ci-approver-message">{msg}</Note>}
    </Panel>
  );
};
